import config from 'config';

const LOAD = 'horse-racing/my-stable-trainer-search/LOAD';
const LOAD_SUCCESS = 'horse-racing/my-stable-trainer-search/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/my-stable-trainer-search/LOAD_FAIL';
const RESET = 'horse-racing/my-stable-trainer-search/RESET';

const initialState = {
  loaded: false,
  trainerSearchResults : []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        trainerSearchResults: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    case RESET:
      return {
        ...state,
        trainerSearchResults: [],
        searchText: ""
      }
    default:
      return state;
  }
}

export function resetTrainers() {
  return {
    type: RESET
  }
}

export function areTrainersLoaded() {
  return false;
}

export function loadTrainers(name) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => name ? client.get(config.api.horseRacing.trainer, { params: {name}})
                              : Promise.resolve([])
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/myStableTrainerSearch.js